import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        company: '=',
        countries: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'manage.Add company' | translate }}</h1>
        </div>
        <manage-permissions-companies-form-general-data company="vm.company" form="vm.form" countries="vm.countries"/>
        <ul class="actions01">
            <li>
                <a ui-sref="authorized.manage.permissions.companies.list()" class="btn discrete" >
                    <span>{{ 'general.Cancel' | translate }}</span>
                </a>
            </li>
        </ul>
    `
})
export default class {
    constructor (FormFactory, COMPANY_SKIN_ENUM) {
        this.form = FormFactory.create(this.company, model => model.$save());
        // set default skin on add
        this.form.model.skin = COMPANY_SKIN_ENUM.KEYS.COURSY;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/companies/add/index.js